import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Spinner from "../../../Components/Spinner";
import ErrorMessage from "../../../Components/ErrorMessage";
import { useLanguage } from "../../../Translations/LenguageContext";

const DeleteChatModal = ({ show, handleClose, recordObject, fetchRecords, endpoint, record_type, message }) => {
    const { t } = useLanguage()
    const user_id = sessionStorage.getItem("user_id")
    const [error, setError] = useState({ message: "", display: false });
    const [inputValue, setInputValue] = useState("");
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [loadingDel, setLoadingDel] = useState(false)
    const [recordId, setRecordId] = useState("");
    const [orgName] = useState("Delete");

    useEffect(() => {
        if (recordObject) {
            setRecordId(recordObject._id || "");
        }
    }, [recordObject]);


    const handleCloseModal = () => {
        setRecordId("")
        setIsButtonDisabled(true);
        handleClose()
        setError({ message: "", display: false })
        setInputValue("")
    }

    const deleteOrganization = async () => {
        try {
            setLoadingDel(true)
            const response = await fetch(`https://aiservice.erioon.com/${endpoint}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id: user_id, record_id: recordId }),
            });
            setLoadingDel(false)
            if (response.ok) {
                handleCloseModal()
                fetchRecords()
            } else {
                setError({ message: t.err_delete_general, display: true })
            }
        } catch (err) {
            setLoadingDel(false)
            setError({ message: t.err_delete_general, display: true })
        }
    };

    return (
        <Modal show={show} onHide={handleCloseModal} className="modal_delete">
            <div className="modal_header">
                <p>Do you want to delete this chat?</p>
                {/* <i className="fa-solid fa-x" onClick={handleCloseModal}></i> */}
            </div>
            <div className="modal_body">
                <p className="warning_delete_message">{message}</p>
            </div>
            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                    <button
                        className={`delete_btn delete_btn_active`}
                        onClick={deleteOrganization}
                    >
                        {loadingDel ? (
                            <Spinner loading={loadingDel} />
                        ) : (
                            <>{t.delete}</>
                        )}
                    </button>
                    <button className="cancel_btn" onClick={handleCloseModal}>{t.cancel}</button>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteChatModal;
